<div class="push-notification-page">
  <div class="conatiner-page-header">Push Notifications</div>
  <mat-tab-group [(selectedIndex)]="selectedIndex" animationDuration="0ms">
    <mat-tab label="Create">
      <app-create-notification></app-create-notification>
    </mat-tab>
    <mat-tab label="Send">
      <app-send-notification *ngIf="selectedIndex == 1"></app-send-notification>
    </mat-tab>
  </mat-tab-group>
</div>
